import { render, staticRenderFns } from "./MainArticles.vue?vue&type=template&id=e2a19960&"
import script from "./MainArticles.vue?vue&type=script&lang=js&"
export * from "./MainArticles.vue?vue&type=script&lang=js&"
import style0 from "./MainArticles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports